module.exports = __webpack_public_path__ + "fdf37cfd41d4ea70c531a362de42b0cf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/boat-shoes-brown-s.png
// module id = 2489
// module chunks = 0